import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const find = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/extract?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o extrato')
        })
}

export default {
    find
}
